import React from 'react';
import { BadgeCheck, CreditCard, Clock, ThumbsUp, ShieldCheck, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
export function BenefitSection() {
  const customerBenefits = [{
    icon: <BadgeCheck className="h-6 w-6 text-primary" data-id="element-135" />,
    title: 'Verified Professionals',
    description: 'All service providers are certified and quality-checked.'
  }, {
    icon: <CreditCard className="h-6 w-6 text-primary" data-id="element-136" />,
    title: 'Flexible Payments',
    description: '0% installment options with multiple payment methods.'
  }, {
    icon: <Clock className="h-6 w-6 text-primary" data-id="element-137" />,
    title: 'Warranty Protection',
    description: 'Every service comes with a comprehensive warranty.'
  }, {
    icon: <ShieldCheck className="h-6 w-6 text-primary" data-id="element-138" />,
    title: 'Quality Assurance',
    description: 'Standardized processes ensure consistent quality.'
  }, {
    icon: <Star className="h-6 w-6 text-primary" data-id="element-139" />,
    title: 'Transparent Pricing',
    description: 'Clear, upfront pricing with no hidden charges.'
  }, {
    icon: <ThumbsUp className="h-6 w-6 text-primary" data-id="element-140" />,
    title: 'Satisfaction Guarantee',
    description: "We ensure you're completely satisfied with the service."
  }];
  return <section id="benefits" className="py-16 bg-gray-50" data-id="element-141">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
        <div className="text-center" data-id="element-143">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-144">
            Customer Benefits
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-145">
            Why homeowners choose Smart Homebox for their service needs
          </p>
        </div>
        <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-146">
          {customerBenefits.map((benefit, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-147">
              <div className="flex items-start" data-id="element-148">
                <div className="flex-shrink-0 h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center mr-4" data-id="element-149">
                  {benefit.icon}
                </div>
                <div data-id="element-150">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-151">
                    {benefit.title}
                  </h3>
                  <p className="mt-1 text-gray-600" data-id="element-152">{benefit.description}</p>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-153">
          <Link to="/request-service" className="px-6 py-3 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors inline-block" data-id="element-154">
            Request Service Now
          </Link>
        </div>
      </div>
    </section>;
}